import request from '@/utils/request'

/** 开具发票列表待开数
 *  地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=555
 */
export function getNeedAddCount(params) {
  return request({
    url: '/invoice/need_add_count',
    method: 'get',
    params: params
  })
}
/* -----发票管理----------------------------------------- */

/**
 * 会员开具发票vip_list
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=778
 */
export function invoiceVipList(params) {
  return request({
    url: '/invoice/member_invoice_list',
    method: 'post',
    data: params
  })
}
/**
 * 开具发票Ukey_list
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=409
 */
export function invoiceUkeyList(params) {
  return request({
    url: '/invoice/ukey_list',
    method: 'post',
    data: params
  })
}

/**
 * 开具发票 手续费列表
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=411
 */
export function invoiceFeeList(params) {
  return request({
    url: '/invoice/service_list',
    method: 'post',
    data: params
  })
}

/**
 * 服务费发票列表操作 开发票和查看页面
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=559
 */
export function invoiceFeeDetail(type, data) {
  const urlMap = {
    vip: '/invoice/member_invoice_info',
    fee: '/invoice/service_info',
    ukey: '/invoice/ukey_info'
  }
  return request({
    url: urlMap[type],
    method: 'get',
    params: data
  })
}

/** 上下两个接口合并成一个
 * Ukey发票列表操作 开发票和查看页面
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=557
 */
// export function invoiceUkeyDetail(params) {
//   return request({
//     url: '/invoice/ukey_info',
//     method: 'get',
//     params: params
//   })
// }

/** 开发票提交的接口
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=556
 * @param file stream 发票图片
 * @param id 本条数据id
 * @param invoice_type 1：ukey发票 2：手续费发票
 * @param express_name 物流公司
 * @param express_no 运单号
 */
export function invoiceAdd(type, params) {
  const url = type === 'vip' ? '/invoice/member_invoice_check' : '/invoice/do_add'
  return request({
    url: url,
    method: 'post',
    data: params,
    formData: true
  })
}
/** 发票信息审核页 ----------------------------------------------------------------------------*/
/** 列表数据
 *  地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=546
 */
export function getReviewList(params) {
  return request({
    url: '/invoice/review_list',
    method: 'get',
    params: params
  })
}

/** 发票审核查看 页面信息
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=549
 * @param company_type 0:工业 1: 服务
 * @param invoice_id 数据id
 */
export function getReviewDetail(params) {
  return request({
    url: '/invoice/review_detail',
    method: 'get',
    params: params
  })
}

/** 发票信息审核通过
 *  地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=560
 *  @param company_type
 *  @param invoice_id
 */
export function reviewAccepte(params) {
  return request({
    url: '/invoice/review_accept',
    method: 'POST',
    data: params
  })
}

/** 发票信息审核驳回
 *  地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=560
 *  @param company_type
 *  @param invoice_id
 *  @param reason
 */
export function reviewReject(params) {
  return request({
    url: '/invoice/review_reject',
    method: 'POST',
    data: params
  })
}
